import { render, staticRenderFns } from "./CreateReportFromTemplateModal.vue?vue&type=template&id=3bcd3cf3&"
import script from "./CreateReportFromTemplateModal.vue?vue&type=script&lang=ts&"
export * from "./CreateReportFromTemplateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports